export interface Instance {
    ownerId: string;
    name: string;
    id?: string;

    places?: InstancePlace[];

    minRating?: number;
    dateFormat?: DateFormat;
    nameFormat?: NameFormat;
    speed?: number;
    fontFamily?: string;
    fontSize?: number;
    size?: number;
    width?: number;

    fullWidth?: boolean;
    textOnly?: boolean;
    randomOrder?: boolean;
    showSourceLogo?: boolean;
    textColor?: string;
    backgroundColor?: string;

    planId?: string;
    trialEndsAt?: Date;
    hideReviewsOlderThanDays?: number;
}

export interface InstancePlace {
    placeId: string;
    placeSecondaryId?: string;
    placeName: string;
};

export type DateFormat = 'DD/MM/YYYY' | 'MM/DD/YYYY' | 'Hide';
export const DATE_FORMATS_ORDER: DateFormat[] = ['DD/MM/YYYY', 'MM/DD/YYYY', 'Hide'];
export const DATE_FORMAT_LABELS: Record<DateFormat, string> = {
    'DD/MM/YYYY': 'Day/Month/Year',
    'MM/DD/YYYY': 'Month/Day/Year',
    'Hide': 'Hide',
}


export type NameFormat = 'Full' | 'FirstNameLastInitial' | 'FirstName' | 'Initials';
export const NAME_FORMATS_ORDER: NameFormat[] = ['Full', 'FirstNameLastInitial', 'FirstName', 'Initials'];
export const NAME_FORMAT_LABELS: Record<NameFormat, string> = {
    'Full': 'Full name',
    'FirstNameLastInitial': 'First name + initial',
    'FirstName': 'First name',
    'Initials': 'Initials',
}
